import { Button, Space, Spin, Table, Tag } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import WrapActionInven from '../wrap-action/WrapActionInven';
import inventoryService from '@root/modules/Warehouse/Inventory/service/inventory';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import moment from 'moment';
import useDebounce from '@root/core/hooks/useDebounce';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import { Product } from '@root/modules/Sellers/Shipping/interfaces';

interface DataInvenDetail {
  id: React.Key;
  productName: string;
  sku: number;
  quantity: number;
  location: string;
  updateDate: string;
  data: {
    productImported: Product;
  }
}

const WrapInfo = () => {
  const [listExSell, setListExSell] = useState([] as any);
  const history = useHistory();
  const [sort, setSort] = useState(true);
  const [query, setQuery] = useState();

  const [listInventory, setListInventory] = useState([] as any);
  const { idSellName }: any = useParams();
  const [searchBy, setSearchBy] = useState('');
  const [labelSelect, setLabelSelect] = useState({
    key: '1',
    label: 'Select'
  } as any);
  const [totalPages, setTotalPages] = useState(1);
  const [filter, setFilter] = useState([] as any);
  const [page, setPage] = useState(1);
  const [filterDate, setFilterDate] = useState<[string, string]>();

  const fromDt: any = (filterDate && filterDate[0]) || '';
  const toDt: string = (filterDate && filterDate[1]) || '';
  const [valueSearch, setValueSearch] = useState('');
  const [isSearch, setIsSearch] = useState('');
  const debounc = useDebounce(valueSearch, 1000);
  const [loading, setLoading] = useState(false);

  /*--------------data to map table-------------*/
  const columns: ColumnsType<DataInvenDetail> = [
    {
      title: 'No',
      dataIndex: 'id'
      // render: (text, record, index) => index + 1
    },
    {
      title: 'Product name',
      dataIndex: 'productName'
    },
    {
      title: 'SKU',
      dataIndex: 'sku'
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity'
    },

    {
      title: 'Location',
      dataIndex: 'location'
    },

    {
      title: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          Update Date
          {!sort ? (
            <UpOutlined
              style={{ marginLeft: '10px' }}
              onClick={() => {
                setSort(true);
                setPage(1);
              }}
            />
          ) : (
            <DownOutlined
              style={{ marginLeft: '10px' }}
              onClick={() => {
                setSort(false);

                setPage(1);
              }}
            />
          )}
        </div>
      ),
      dataIndex: 'updatedAt'
    }
  ];

  /*----------------------------checkbox---------------------*/
  const rowSelectionn = {
    onChange: (
      selectedRowKeys: React.Key[],
      selectedRows: DataInvenDetail[]
    ) => {
      setListExSell(selectedRows);
    },
    getCheckboxProps: (record: DataInvenDetail) => ({
      //   disabled: record.sellerName === 'Disabled User',
      //   name: record.sellerName
    })
  };

  /*-------------------------------paging---------------------------------*/

  const getSelect = (e: any) => {
    setSearchBy(e.key);
    setLabelSelect({ key: e.key, label: e.domEvent.target.innerText });
  };

  const handelPagination = async (
    page: number,
    fromDt: string,
    toDt: string,
    searchBy: string,
    filterInput: string,
    sort: boolean
  ) => {
    setLoading(true);
    const res = await inventoryService.getDetailTable(
      idSellName,
      page,
      fromDt,
      toDt,
      searchBy,
      filter,
      filterInput,
      sort
    );
    const rowData = res.data?.map((row: any) => {
      return {
        ...row,
        key: row.id,
        // param: row.sellerId,
        updatedAt: formatDateTime(row.updatedAt)
      };
    });

    setListInventory(rowData);
    setTotalPages(res.count);
    setLoading(false);
  };

  useEffect(() => {
    if (!!valueSearch && !!setSearchBy) setIsSearch(valueSearch);
    else if (!!isSearch && !valueSearch) {
      setIsSearch('');
      setPage(1);
    }
  }, [debounc, setSearchBy]);

  useEffect(() => {
    handelPagination(1, fromDt, toDt, searchBy, valueSearch, sort);
    setPage(1);
  }, [isSearch, fromDt, toDt, sort, searchBy]);

  /*-----------------------------search-----------------------------------*/

  const onChangeSearch = (name: string, value: string) => {
    setValueSearch(() => {
      return value;
    });
  };
  const getDateValue = (value: [string, string]) => {
    setFilterDate(value);
    setPage(1);
  };

  const SearchName = () => {
    handelPagination(1, fromDt, toDt, searchBy, valueSearch, sort);
    setPage(1);
  };

  /*------------------------------export excel----------------------------------*/

  const idMap = listExSell.map((item: any) => item.key);

  const arrId = {
    ids: idMap
  };

  const handleOnExportIn = async () => {
    if (listExSell.length === 0) {
      const response = await inventoryService.postDownExcelInven(
        idSellName,
        fromDt,
        toDt,
        searchBy,
        valueSearch,
        sort
      );
      const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      const outputFilename = `Stock_ ` + utc + `.xlsx`;
      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    } else {
      const response = await inventoryService.postDownExcelInvenId(
        idSellName,
        arrId
      );
      const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      const outputFilename = `Stock_ ` + utc + `.xlsx`;
      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    }
  };

  return (
    <Spin spinning={loading}>
      <div style={{ marginTop: '15px' }}>
        <WrapActionInven
          WrapAction
          getSelect={getSelect}
          labelSelect={labelSelect}
          onChangeSearch={onChangeSearch}
          getDateValue={getDateValue}
          onSearchName={SearchName}
        />
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '15px 17px',
          background: 'white',
          alignItems: 'center'
        }}
      >
        <div>
          <span style={{ marginLeft: '8px', marginRight: '8px' }}>
            Total inventory {totalPages}
          </span>
          <div
            className="ant-divider ant-divider-vertical"
            role="separator"
          ></div>
          {listExSell.length === 0 ? (
            <span style={{ marginLeft: '8px', marginRight: '8px' }}>
              Select inventory 00
            </span>
          ) : (
            <span style={{ marginLeft: '8px', marginRight: '8px' }}>
              Select inventory {listExSell.length}
            </span>
          )}
        </div>

        <div>
          <Button className="downExcel" onClick={handleOnExportIn}>
            Download Excel
          </Button>
        </div>
      </div>
      <Table
        className="warehouse-table"
        columns={columns}
        dataSource={listInventory}
        rowSelection={rowSelectionn}
        pagination={{
          total: totalPages,
          current: page,

          onChange: (page, limit) => {
            setPage(page);

            handelPagination(page, fromDt, toDt, searchBy, valueSearch, sort);
          }
        }}
        onRow={(item) => {
          return {
            onClick: () => {
              history.push(`/admin/inventory-details/${item.id}/product/${item.data.productImported.id}`);
            }
          };
        }}
      />
    </Spin>
  );
};

export default WrapInfo;
